export const geoJsonSource: any = {
    type: 'geojson',
    data: {
        type: 'FeatureCollection',
        features: [] as any
    }
};
